(function (Drupal, once, $) {
  Drupal.behaviors.helpPopup = {
    attach(context) {

      function addOverlayClass(dialogElement) {
        const overlays = document.querySelectorAll('.ui-widget-overlay');
        const overlay = overlays[overlays.length - 1];

        if (overlay) {
          overlay.classList.add('help-popup-overlay');
          dialogElement.helpPopupOverlay = overlay;

          // NEW: Add click event to close the dialog
          overlay.addEventListener('click', () => {
            if (dialogElement.helpPopupDialog) {
              dialogElement.helpPopupDialog.close();
            }
          });
        }
      }

      function removeOverlayClass(dialogElement) {
        if (dialogElement.helpPopupOverlay) {
          // Optional: remove listener if you're worried about memory,
          // though the element is usually destroyed by jQuery UI.
          dialogElement.helpPopupOverlay.classList.remove('help-popup-overlay');
          dialogElement.helpPopupOverlay = null;
        }

        document
          .querySelectorAll('.ui-widget-overlay.help-popup-overlay')
          .forEach((overlay) => {
            overlay.classList.remove('help-popup-overlay');
          });
      }

      once('help-popup-trigger', '.help-popup-trigger', context).forEach((trigger) => {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();

          const targetSelector = this.getAttribute('data-dialog-target');
          const dialogElement = document.querySelector(targetSelector);

          if (!dialogElement) return;

          dialogElement.classList.remove('visually-hidden');

          if (!dialogElement.helpPopupDialog) {
            dialogElement.helpPopupDialog = Drupal.dialog(dialogElement, {
              title: '',
              modal: true,
              classes: {
                'ui-dialog': 'help-popup-dialog'
              },
              open() {
                addOverlayClass(dialogElement);
              },
              close() {
                dialogElement.classList.add('visually-hidden');
                removeOverlayClass(dialogElement);
              }
            });
          }

          dialogElement.helpPopupDialog.showModal();
        });
      });

      once('help-popup-close', '.help-popup-close', context).forEach((closeButton) => {
        closeButton.addEventListener('click', function (e) {
          e.preventDefault();
          const dialogElement = this.closest('.help-popup-content');
          if (dialogElement && dialogElement.helpPopupDialog) {
            dialogElement.helpPopupDialog.close();
          }
        });
      });
    }
  };
})(Drupal, once, jQuery);
